fragment UserTableFragment on User {
    id
    name
    redirectUrl
    isEnabled
    emailAddresses {
        id
        address
    }
    teams {
        id
        name
    }
    role {
        id
        name
    }
    licenses {
        licenseType
        isOwned
    }
    hasTwoFactorEnabled
    hasMailSyncEnabled
    lastSeen
}
